//import Vue from 'vue'
import Bb8 from './Bb8.vue'

if (document.querySelector('#bb8')) {
  new Vue({
    el: '#bb8',

    components: {
      Bb8
    }
  })
}



// WEBPACK FOOTER //
// ./src/main.js